type SortOrder = 'asc' | 'desc'

const comparator = <T extends {}>(key: keyof T, sortOrder: SortOrder) => {
  const isDescending = sortOrder === 'desc'

  return (d1: T, d2: T): number => {
    const c1 = d1[key]
    const c2 = d2[key]
    const c1IsDefined = typeof c1 !== 'undefined' && c1 !== null
    const c2IsDefined = typeof c2 !== 'undefined' && c2 !== null

    if (c1IsDefined && c2IsDefined) {
      if (c1 > c2) {
        return isDescending ? 1 : -1
      } else if (c2 > c1) {
        return isDescending ? -1 : 1
      }
    } else if (c1IsDefined) {
      return isDescending ? 1 : -1
    } else if (c2IsDefined) {
      return isDescending ? -1 : 1
    }

    return 0
  }
}

export {
  comparator
}
